import { useContext, useState } from 'react'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastError, toastSuccess } from '../../../../utils/toast'
import Tooltip from '../../../Utilities/Tooltip'

const ClearChatPolicy = () => {
  const {
    [SETTINGS.CLEAR_CHAT_POLICY.key]: clearChatPolicy,
    [SETTINGS.FEATURES.key]: features
  } = useContext(SiteConfigContext)
  const { updateSetting } = useContext(SiteConfigContext)

  const [mode, setMode] = useState(clearChatPolicy.mode)

  if (!features.publicchat) return <></>

  const handleSubmit = async (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const fields = Object.fromEntries(formData)
    const updatedPolicy = {
      ...clearChatPolicy,
      ...fields
    }

    const response = await updateSetting(
      SETTINGS.CLEAR_CHAT_POLICY,
      updatedPolicy
    )

    if (response && (response.status === 200 || response.status === 201)) {
      toastSuccess('Clear chat policy updated.')
    } else {
      toastError('Failed to update clear chat policy.')
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <h2>Clear Chat Policy</h2>
        <Tooltip>Select a policy to handle clearing public chat.</Tooltip>
      </div>
      <form className="flex gap-2" onSubmit={handleSubmit}>
        <select
          className="input p-2"
          name="mode"
          defaultValue={mode}
          onChange={(e) => setMode(e.target.value)}
        >
          <option value="none">None</option>
          <option value="scheduled">Scheduled</option>
          <option value="rolling">Rolling</option>
          <option value="manual">Manual</option>
        </select>
        <button type="submit" className="button-confirm w-fit">
          Save
        </button>
      </form>
    </div>
  )
}

export default ClearChatPolicy
